 
import "./architectureSection.css";

export default function ArchitectureSection() {
  return (
    <section className="ryse-architecture">
      <div className="ryse-architecture__card">
        <p className="ryse-architecture__text">
          Unlike traditional systems that rely on generic AI models, Ryse
          separates language interpretation from execution. Generative AI only
          understands the request; specialized computational Agents perform the
          analytics — from correlation matrices and risk engines to Monte Carlo
          simulations and non-linear dependency modeling.
        </p>

        <div className="ryse-architecture__highlight">
          <p className="ryse-architecture__highlight-text">
            This architecture eliminates hallucinations, ensures mathematical
            precision, and enables professionals to interact with complex
            analytics as naturally as having a conversation with an expert.
          </p>
        </div>
      </div>
    </section>
  );
}
